import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=015d663c&scoped=true&"
import script from "./NewsList.vue?vue&type=script&lang=ts&"
export * from "./NewsList.vue?vue&type=script&lang=ts&"
import style0 from "./NewsList.vue?vue&type=style&index=0&id=015d663c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d663c",
  null
  
)

export default component.exports